const AuthFormButton = ({ children, className = '', type = 'submit', disabled = false, onClick }: any) => {
    return (
        <button
            type={type}
            disabled={disabled}
            onClick={onClick}
            className={`md:w-[10rem] p-[8px] md:p-0 w-full h-10 bg-primary text-white rounded-full font-semibold transition hover:bg-[#162061] disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
        >
            {children}
        </button>
    );
};

export default AuthFormButton;
